<template>
  <div>
    <div class="block manage-filter">
      <div class="manage-filter__search">
        <label class="input-label manage-filter__search-label">Search</label>
        <b-form-input v-model="filter" placeholder="Search Campaign" name='filter' class="input-default input-default--search"/>
      </div>
      <div class="manage-filter__controls">
        <button class="button button--primary manage-filter__controls-item"><i class="fa fa-list-alt button__icon"></i> My lists</button>
        <button class="button button--primary manage-filter__controls-item manage-filter__controls-item--active"><i class="fa fa-lock button__icon"></i> System</button>
      </div>
      <div class="manage-filter__clear">
        <button class="button button--primary manage-filter__clear-button" :disabled="!filter" @click="filter = ''"><i class="fa fa-repeat button__icon"></i> Clear</button>
      </div>
      <div class="manage-filter__divider-hr"></div>
      <newDomain/>
    </div>

    <div class="block manage-table">
      <div class="manage-table__head">
          <h3 class="manage-table__title">Selected Records: 0</h3>
          <div class="manage-table__controls">
              <button class="button button--small button--service"><i class="fa fa-columns button__icon"></i> Columns</button>
          </div>
          <div class="manage-table__display">
              <div class="manage-table__display-item manage-table__display-item--active">
                  <img src="/static/img/admin/display-01.svg" alt="" class="manage-table__display-item-img">
              </div>
              <div class="manage-table__display-item">
                  <img src="/static/img/admin/display-02.svg" alt="" class="manage-table__display-item-img">
              </div>
              <div class="manage-table__display-item">
                  <img src="/static/img/admin/display-03.svg" alt="" class="manage-table__display-item-img">
              </div>
          </div>
      </div>
      <div class="manage-table__body">
          <div class="table table--nbrus table--nbr">
              <div class="table__body">
                  <b-table ref="campaigntable"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :items="domainProvider"
                    :fields="fields"
                    @filtered="onFiltered"
                    class="table__main"
                    thead-tr-class="table__row"
                    tbody-tr-class="table__row"
                  >
                  </b-table>
              </div>
              <div class="table__controls">
                  <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    first-text=""
                    prev-text=""
                    next-text=''
                    last-text=''
                    class="table__pagination"/>
                  <div class="table__active-pages">
                    <input v-model.number="perPage" type="number" class="table__active-pages-input" />
                    <div class="table__active-pages-controls">
                      <button class="table__active-pages-button table__active-pages-button--up"><i class="fa fa-caret-up" @click="perPage++"></i></button>
                      <button class="table__active-pages-button table__active-pages-button--down"><i class="fa fa-caret-down" @click="perPage--"></i></button>
                    </div>
                  </div>
                  <div class="table__pages">{{ (currentPage === 1) ? currentPage : (currentPage * perPage - perPage) }} - {{ currentPage + perPage }} of {{ totalRows }} records</div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiCall from '@/utils/api'
import newDomain from './newdomain'

export default {
  name: 'DomainLists',
  components: {
    newDomain
  },
  data () {
    return {
      fields: [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'name', label: 'Name', sortable: true },
        { key: 'domains', label: 'Domains', sortable: false },
        { key: 'timestamp', label: 'Updated', sortable: true }
      ],
      perPageStr: '',
      sortBy: 'id',
      sortDesc: false,
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      filter: null
    }
  },
  methods: {
    domainProvider (ctx) {
      let promise = apiCall({controller: 'DomainList', data: { ctx: ctx }, method: 'GET'})
      return promise.then((data) => {
        this.totalRows = Object.keys(data.data.response).length
        let items = Object.values(data.data.response)
        return (items || [])
      })
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>

<style>
.button--primary{
  padding: .7rem .5rem .6rem;
}
.manage-filter__controls-item--active {
    background: #0878C8 !important;
}
.button--secondary-fill{
  padding: .7rem 2.5rem .6rem;
}
.table__row th {
    padding: .8rem 1.5rem;
    color: #969CAA;
    font-size: 1.2rem;
    text-transform: uppercase;
    font-weight: 600;
    text-align: left;
    background-color: #E8ECF3;
    border-right: solid .1rem #DAE1ED;
    border-bottom: solid .1rem #DAE1ED;
}
</style>



// WEBPACK FOOTER //
// src/components/advertiser/campaign/manager/domains.vue